import { apiSync, ApiError } from "../api.js";
import { navigate } from "../main.js";
import { clearSession, state } from "../state.js";

export function renderStart(root: HTMLElement) {
  if (!state.session) {
    navigate("login");
    return;
  }

  root.innerHTML = `
    <div class="center-stage">
      <div class="center-card">
        <h1>Pronto pra buscar</h1>
        <p>
          Vou buscar e analisar todos os seus holerites publicados no Questor Zen.
          Pode levar entre 10 e 30 segundos dependendo do volume.
        </p>
        <div style="display: flex; gap: 10px; align-items: center; margin-top: 18px;">
          <button class="btn accent" id="buscar">Buscar meus holerites</button>
          <button class="btn secondary" id="sair">Sair</button>
        </div>
        <div id="status" class="subtitle" style="margin-top: 16px;"></div>
      </div>
    </div>
  `;

  const buscar = root.querySelector<HTMLButtonElement>("#buscar")!;
  const sair = root.querySelector<HTMLButtonElement>("#sair")!;
  const status = root.querySelector<HTMLDivElement>("#status")!;

  buscar.addEventListener("click", async () => {
    buscar.disabled = true;
    sair.disabled = true;
    status.textContent = "Sincronizando… isso pode levar até 30 segundos.";
    try {
      const data = await apiSync(state.session!);
      state.data = data;
      navigate("dashboard");
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        status.textContent = "Sessão expirada. Redirecionando para o login…";
        setTimeout(() => {
          clearSession();
          navigate("login");
        }, 1200);
        return;
      }
      status.textContent = `Falhou: ${(e as Error).message}`;
      buscar.disabled = false;
      sair.disabled = false;
    }
  });

  sair.addEventListener("click", () => {
    clearSession();
    navigate("login");
  });
}
